import { render, staticRenderFns } from "./permission-description-form.vue?vue&type=template&id=5d76691a&"
import script from "./permission-description-form.vue?vue&type=script&lang=js&"
export * from "./permission-description-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports